// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "https://api.fatash.trangotechdevs.com";
const BASE_URL = "https://api.fatashhealthcare1.com";

const API_URL = BASE_URL + "/api/user/";

const API_URL_NURSE = BASE_URL + "/api/nurse/";

const INITIAL_TOKEN = "1e4ad4bf-d6fe-4db7-87e1-c78b6834a7a5";

export { API_URL, BASE_URL, INITIAL_TOKEN, API_URL_NURSE };
